import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { selectQLEConfiguration } from '../qle-configuration.selectors';

export const selectIsEditHREmailEnabled = createSelector(
  selectQLEConfiguration,
  get('isEditHREmailEnabled'),
);
